export default __webpack_public_path__ + "static/media/bowser.9daa5a86.webp";